export const API_BASE_URL = "https://solvei-api.onrender.com/api/";
// export const API_BASE_URL = "http://localhost:8080/api/"
export const AUTH = "auth/";
export const USER = "user/?email="
export const REG = "register/"
export const HOME = "course/";
export const LOGIN = "login/";
export const QUESTION_SEARCH = "search/question?"
export const COURSE_SEARCH = "search/course?"

export const position = ['0', '1st', '2nd', '3rd', '4th']

